<template>
	<div style="padding-top:-2px;margin-top:-2px;">
		<v-label
			><b>{{ label }}</b></v-label
		>
		<v-select
			height="40"
			class="text"
			v-if="!autocomplete"
			ref="text"
			@blur="handleBlur"
			:readonly="readonly"
			:return-object="returnObject"
			:disabled="disabled"
			dense
			placeholder=" "
			:outlined="outlined"
			:dark="dark"
			max="1"
			hide-details="auto"
			:items="items"
			:item-value="itemValue"
			:item-text="itemText"
			:autofocus="autofocus"
			aria-autocomplete="off"
			autocomplete="true"
			:maxlength="max"
			:color="color"
			:value="value"
			@click="click()"
			@input="inputText($event)"
			@keyup.enter="enter"
			@keypress="validation($event)"
			:type="type"
			:clearable="clearable"
			@click:clear="clickClear"
			@change="handleChange"
			:rules="computedRules"
			:error="hasError"
			:error-messages="errorMessage"
			:multiple="multiple"
		>
			<template v-slot:prepend> <slot name="prepend"> </slot></template>
			<template v-slot:prepend-inner> <slot name="prepend-inner"> </slot></template>
			<template v-slot:append> <slot name="append"> </slot></template>
			<template v-slot:append-outer> <slot name="append-outer"> </slot></template>
			<template v-if="slotTmp" v-slot:item="data">
                <slot name="item" :item="data.item"> </slot>
            </template>
			<template v-if="multiple" v-slot:prepend-item>
				<v-list-item
					ripple
					@mousedown.prevent
					@click="toggleSelectAll"
				>
					<v-list-item-action class="mr-4">
						<v-icon :color="value && value.length > 0 ? 'primary' : ''">
							{{ selectAllIcon }}
						</v-icon>
					</v-list-item-action>
					<v-list-item-content>
						<v-list-item-title class="font-weight-medium">
							{{ isAllSelected ? 'Desmarcar todos' : 'Seleccionar todos' }}
						</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
				<v-divider class="mb-1"></v-divider>
			</template>
			<template v-if="multiple" v-slot:selection="{ item, index }">
				<div v-if="index === 0" class="d-flex align-center w-100" style="max-width: 100%; overflow: hidden;">
					<span class="text-caption text-truncate text-capitalize grey--text text--darken-4 pl-1" style="max-width: 75%;">
						{{ firstItemText }}
					</span>
					<span v-if="value.length > 1" class="additional-count-badge ml-1">
						+{{ value.length - 1 }}
					</span>
				</div>
			</template>
		</v-select>
		<v-autocomplete
			v-else
			:search-input.sync="searchQuery"
			height="40"
			class="text"
			ref="text"
			@blur="handleBlur"
			:readonly="readonly"
			:return-object="returnObject"
			:disabled="disabled"
			dense
			placeholder=" "
			outlined
			:dark="dark"
			max="1"
			hide-details="auto"
			:items="items"
			:item-value="itemValue"
			:item-text="itemText"
			:autofocus="autofocus"
			aria-autocomplete="off"
			autocomplete="true"
			:maxlength="max"
			:color="color"
			:value="value"
			@click="click()"
			@input="inputText($event)"
			@keyup.enter="enter"
			@keypress="validation($event)"
			:type="type"
			:clearable="clearable"
			@change="handleChange"
			:rules="computedRules"
			:error="hasError"
			:error-messages="errorMessage"
			:multiple="multiple"
		>
			<template v-slot:prepend> <slot name="prepend"> </slot></template>
			<template v-slot:prepend-inner> <slot name="prepend-inner"> </slot></template>
			<template v-slot:append> <slot name="append"> </slot></template>
			<template v-slot:append-outer> <slot name="append-outer"> </slot></template>
			<template v-if="slotTmp" v-slot:item="data">
                <slot name="item" :item="data.item"> </slot>
            </template>
			<template v-if="multiple" v-slot:prepend-item>
				<v-list-item
					ripple
					@mousedown.prevent
					@click="toggleSelectAll"
				>
					<v-list-item-action class="mr-4">
						<v-icon :color="value && value.length > 0 ? 'primary' : ''">
							{{ selectAllIcon }}
						</v-icon>
					</v-list-item-action>
					<v-list-item-content>
						<v-list-item-title class="font-weight-medium">
							{{ isAllSelected ? 'Desmarcar todos' : 'Seleccionar todos' }}
						</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
				<v-divider class="mb-1"></v-divider>
			</template>
			<template v-if="multiple" v-slot:selection="{ item, index }">
				<div v-if="index === 0" class="d-flex align-center w-100" style="max-width: 100%; overflow: hidden;">
					<span class="text-caption text-truncate text-capitalize grey--text text--darken-4 pl-1" style="max-width: 85%;">
						{{ firstItemText }}
					</span>
					<span v-if="value.length > 1" class="additional-count-badge ml-1">
						+{{ value.length - 1 }}
					</span>
				</div>
			</template>
		</v-autocomplete>
	</div>
</template>

<script>
	export default {
		components: {},
		props: {
			items: null,
			value: null,
			outlined: { type: Boolean, default: true },
			color: { type: String, default: "primary" },
			label: { type: String, default: "" },
			itemValue: { type: String, default: "value" },
			itemText: { type: String, default: "text" },
			max: { type: String, default: "256" },
			width: { type: String, default: "default" },
			type: { type: String, default: "text" },
			dark: { type: Boolean, default: false },
			returnObject: { type: Boolean, default: false },
			autofocus: { type: Boolean, default: false },
			disabled: { type: Boolean, default: false },
			readonly: { type: Boolean, default: false },
			number: { type: Boolean, default: false },
			autocomplete: { type: Boolean, default: false },
			decimal: { type: Boolean, default: false },
			clearable: { type: Boolean, default: false },
			search: { type: Boolean, default: false },
			slotTmp: {type: Boolean, default: false},
			rules: { type: Array, default: () => [] },
			multiple: { type: Boolean, default: false }
		},
		watch: {
			config() {},
			value() {
				this.$emit("input", this.value);
			}
		},
		computed: {
			computedRules() {
				let currentRules = [...(this.rules || [])];
				if (this.hasError && this.errorMessage) {
					currentRules.push(() => this.errorMessage);
				}
				return currentRules;
			},
			selectedObjects() {
				if (!this.multiple || !this.value || !Array.isArray(this.value)) {
					return [];
				}
				if (this.returnObject) {
					return this.value;
				}
				return this.items ? this.items.filter(item => this.value.includes(item[this.itemValue])) : [];
			},
			firstItemText() {
				if (!this.multiple || !this.value || !Array.isArray(this.value) || this.value.length === 0) {
					return '';
				}
				const first = this.selectedObjects[0];
				return first ? first[this.itemText] : '';
			},
			selectionText() {
				if (!this.multiple || !this.value || !Array.isArray(this.value) || this.value.length === 0) {
					return '';
				}
				const first = this.selectedObjects[0];
				if (!first) return '';

				const firstText = first[this.itemText];
				if (this.value.length === 1) {
					return firstText;
				}
				return `${firstText} (+${this.value.length - 1} más)`;
			},
			filteredItems() {
				if (!this.items) return [];
				if (!this.autocomplete || !this.searchQuery) {
					return this.items;
				}
				const query = this.searchQuery.toLowerCase().trim();
				if (!query) return this.items;
				return this.items.filter(item => {
					const text = String(item[this.itemText] || '').toLowerCase();
					return text.includes(query);
				});
			},
			isAllSelected() {
				if (!this.filteredItems || this.filteredItems.length === 0) return false;
				return this.filteredItems.every(item => {
					const val = this.returnObject ? item : item[this.itemValue];
					if (this.returnObject) {
						return (this.value || []).some(v => v[this.itemValue] === val[this.itemValue]);
					} else {
						return (this.value || []).includes(val);
					}
				});
			},
			isSomeSelected() {
				if (!this.filteredItems || this.filteredItems.length === 0) return false;
				const selectedFilteredCount = this.filteredItems.filter(item => {
					const val = this.returnObject ? item : item[this.itemValue];
					if (this.returnObject) {
						return (this.value || []).some(v => v[this.itemValue] === val[this.itemValue]);
					} else {
						return (this.value || []).includes(val);
					}
				}).length;
				return selectedFilteredCount > 0 && selectedFilteredCount < this.filteredItems.length;
			},
			selectAllIcon() {
				if (this.isAllSelected) return 'mdi-checkbox-marked';
				if (this.isSomeSelected) return 'mdi-minus-box';
				return 'mdi-checkbox-blank-outline';
			}
		},
		methods: {
			handleChange(value) { 
				this.$emit("change", value); // Emitir el evento si necesitas
			},
			toggleSelectAll() {
				const currentSelection = [...(this.value || [])];
				if (this.isAllSelected) {
					// Deselect only the filtered items
					const newValue = currentSelection.filter(selectedItem => {
						const isFiltered = this.filteredItems.some(item => {
							if (this.returnObject) {
								return item[this.itemValue] === selectedItem[this.itemValue];
							} else {
								return item[this.itemValue] === selectedItem;
							}
						});
						return !isFiltered;
					});
					this.$emit("input", newValue);
					this.$emit("change", newValue);
				} else {
					// Select all filtered items (merge with current selection)
					const newValue = [...currentSelection];
					this.filteredItems.forEach(item => {
						const val = this.returnObject ? item : item[this.itemValue];
						const alreadySelected = currentSelection.some(selectedItem => {
							if (this.returnObject) {
								return selectedItem[this.itemValue] === val[this.itemValue];
							} else {
								return selectedItem === val;
							}
						});
						if (!alreadySelected) {
							newValue.push(val);
						}
					});
					this.$emit("input", newValue);
					this.$emit("change", newValue);
				}
			},
			removeSelectItem(item) {
				const valToRemove = this.returnObject ? item : item[this.itemValue];
				const newValue = (this.value || []).filter(x => {
					if (this.returnObject) {
						return x[this.itemValue] !== valToRemove[this.itemValue];
					} else {
						return x !== valToRemove;
					}
				});
				this.$emit("input", newValue);
				this.$emit("change", newValue);
			},
			click() {
				this.$emit("click");
			},
			handleBlur() {
				this.$emit("blur");
			},
			focus() {
				if(this.$refs.text) this.$refs.text.focus();
			},
			error(msg) {
				if (msg) {
					this.hasError = true;
					this.errorMessage = msg;
				}
				this.focus();
			},
			validation(evt) {
				if (this.number || this.type == "number") {
					evt = evt ? evt : window.event;
					var charCode = evt.which ? evt.which : evt.keyCode;
					if (charCode > 31 && (charCode < 48 || charCode > 57)) {
						evt.preventDefault();
					} else {
						return true;
					}
				}

				if (this.decimal) {
					evt = evt ? evt : window.event;
					var charCode = evt.which ? evt.which : evt.keyCode;
					if (
						charCode > 31 &&
						(charCode < 48 || charCode > 57) &&
						charCode != 46
					) {
						evt.preventDefault();
					} else {
						return true;
					}
				}
			},
			inputText(item) {
				this.hasError = false;
				this.errorMessage = "";
				this.$emit("input", item);
			},
			clickClear() {
				this.$emit("clickClear");
			},
			enter() {
				this.$emit("keyupEnter");
			},
			getAnswer() {
				this.$emit("input", this.value);
			}
		},
		mounted() {
			this.$emit("input", this.value);
		},
		created() {
			this.debouncedGetAnswer = _.debounce(this.getAnswer, 220);
			this.item = this.value;
		},
		data: () => ({
			//ComboBox
			//
			item: "",
			hasError: false,
			errorMessage: "",
			searchQuery: null
		})
	};
</script>
<style scoped>
::v-deep .v-select__selections {
  flex-wrap: nowrap !important;
  overflow: hidden !important;
}

.additional-count-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: #d4edfe;
  color: #1976d2;
  font-size: 0.7rem;
  font-weight: 700;
  padding: 3px 5px;
  border-radius: 4px;
  line-height: 1;
  white-space: nowrap;
}
</style>
